import React from "react";
import { getFilename } from "../../../../../fileUploadUtils";
import { style } from "typestyle";

type Props = {
  value: string;
  label: string;
};

export default function ActionSingleFileCollapsed(props: Props) {
  const { value, label } = props;

  return (
    <div>
      <div
        className={style({
          fontSize: "16px",
          lineHeight: "24px",
          color: "rgba(0,0,0,0.87)",
          marginBottom: "4px",
        })}
      >
        {label}
      </div>
      <div>
        <a
          href={value}
          className={style({
            color: "#089DF4",
            lineHeight: "20px",
            fontSize: "14px",
          })}
        >
          {getFilename(value)}
        </a>
      </div>
    </div>
  );
}
